import React, {PureComponent} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {H4, Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"
import {BrandSettingsChoiceImage, BrandSettingsChoiceImageWrapper, Color, HexCode, AlignButton} from "./styled/styled"

interface Props {
  handleBrandSettingsClickLogo: () => void
  handleBrandSettingsClickColor: () => void
  logo: string
  primaryColour: string
}

class BrandSettings extends PureComponent<Props> {
  render() {
    const {logo, primaryColour} = this.props
    return (
      <Flex wrap="wrap" gap={theme.spacing.five}>
        <Flex direction="column" maxWidth="360px" marginBottom={4}>
          <BrandSettingsChoiceImageWrapper>
            <BrandSettingsChoiceImage src={logo} alt="" />
          </BrandSettingsChoiceImageWrapper>
          <H4 marginBottom={1}>
            <FormattedMessage id="admin.components.brandSettings.headerFour.logo" />
          </H4>
          <Body>
            <FormattedMessage id="admin.components.brandSettings.logo.text" />
          </Body>
          <AlignButton id="settingsUploadLogoButton" marginTop={2} primary onClick={this.props.handleBrandSettingsClickLogo}>
            <FormattedMessage id="admin.components.brandSettings.button.uploadLogo" />
          </AlignButton>
        </Flex>
        <Flex direction="column" maxWidth="360px" marginBottom={4}>
          <Color color={primaryColour}>
            <HexCode>{primaryColour}</HexCode>
          </Color>
          <H4 marginBottom={1}>
            <FormattedMessage id="admin.components.brandSettings.headerFour.brandColour" />
          </H4>
          <Body style={{flexGrow: 1}}>
            <FormattedMessage id="admin.components.brandSettings.brandColour.text" />
          </Body>
          <AlignButton id="settingsSetColourButton" marginTop={2} primary onClick={this.props.handleBrandSettingsClickColor}>
            <FormattedMessage id="admin.components.brandSettings.button.setColour" />
          </AlignButton>
        </Flex>
      </Flex>
    )
  }
}

export default BrandSettings
